import { TReportRtmType } from 'partner360/models/report/TReportRtmType'

/** Partners coverage is collected for Reseller partners only. */
export const COVERAGE_REPORT_RTM: TReportRtmType = 'Reseller'

/** Partners coverage data exists starting from FY26. */
export const COVERAGE_REPORT_MIN_FYEAR = 2026
